import { render, staticRenderFns } from "./JoinFormComponent.vue?vue&type=template&id=52ce48b1&scoped=true&"
import script from "./JoinFormComponent.vue?vue&type=script&lang=js&"
export * from "./JoinFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./JoinFormComponent.vue?vue&type=style&index=0&id=52ce48b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce48b1",
  null
  
)

export default component.exports